import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';


class ScanItemModal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            barcode:"",
        };
        this.handleSubmitItem = this.handleSubmitItem.bind(this);
        this.barcodeInput = React.createRef(null);
        this.handleChange = this.handleChange.bind(this);
    }

    handleSubmitItem(e){
        console.log(e);
        
    }

    componentDidUpdate(prevProps){
        if (this.props.show === true && (prevProps.show !== this.props.show) ) {
            this.barcodeInput.current.focus();
            console.log("chasiermodaldidupdate");
        }
    }
    handleChange(e){

        if(e.target.value.charCodeAt(e.target.value.length-1) === 10){
            
            if(this.props.priceCheck){
                this.props.findProduct(this.state.barcode, false);
            }
            else {
                this.props.findProduct(this.state.barcode, true); 
            }
            // need to submit items from this, search products
            // this.props.findProduct(this.state.barcode, true);
            //if found above then need to clear the input
            this.setState({barcode:""});
        }
        else {

            this.setState({barcode : e.target.value});
            
        }
        
    }

    render(){
        return(
            <React.Fragment>
                <Modal show={this.props.show} onHide={this.props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Scan new item...</Modal.Title>
                </Modal.Header>
                <Modal.Body>Scan shopping then click "Finsh Scanning" to total.
                    <Form.Group>
                        <Form.Label>Barcode</Form.Label>
                        <Form.Control ref={this.barcodeInput} id="barcode"  type="text" onChange={this.handleChange} as="textarea" value={this.state.barcode}/>
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.props.handleClose}>
                        Finish Scanning
                    </Button>
                    {/* <Button variant="primary" onClick={this.props.addItemsOnClick}>
                        Add Item
                    </Button> */}
                    {/* <Button variant="primary" onClick={this.handleSubmitItem}>
                        Add Item 2
                    </Button> */}
                </Modal.Footer>
            </Modal>
            </React.Fragment>

)}
}
export default ScanItemModal
